var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("main-layout", [
    _c("div", { staticClass: "completeDiv" }, [
      _c(
        "div",
        { staticClass: "container" },
        [
          _c("H1", { staticClass: "pageTitle" }, [
            _vm._v("COMPLETE REGISTRATION")
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "columns" }, [
            _c("div", { staticClass: "column" }, [
              _c("div", { staticClass: "limitWidth top40" }, [
                _vm.showForm
                  ? _c(
                      "form",
                      {
                        staticClass: "form accSettingsForm",
                        on: {
                          submit: function($event) {
                            $event.preventDefault()
                            return _vm.submitForm.apply(null, arguments)
                          }
                        }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "field",
                            class: { formError: _vm.errors.first("fName") }
                          },
                          [
                            _vm._v(
                              "\n                            First Name:*\n                            "
                            ),
                            _c("input", {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: "required",
                                  expression: "'required'"
                                },
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.form.fName,
                                  expression: "form.fName"
                                }
                              ],
                              staticClass: "input is-warning",
                              attrs: { type: "text", name: "fName" },
                              domProps: { value: _vm.form.fName },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    _vm.form,
                                    "fName",
                                    $event.target.value
                                  )
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c("p", { staticClass: "help is-danger" }, [
                              _vm._v(
                                "\n                                " +
                                  _vm._s(_vm.errors.first("fName")) +
                                  "\n                            "
                              )
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "field",
                            class: { formError: _vm.errors.first("lName") }
                          },
                          [
                            _vm._v(
                              "\n                            Last Name:*\n                            "
                            ),
                            _c("input", {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: "required",
                                  expression: "'required'"
                                },
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.form.lName,
                                  expression: "form.lName"
                                }
                              ],
                              staticClass: "input is-warning",
                              attrs: { type: "text", name: "lName" },
                              domProps: { value: _vm.form.lName },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    _vm.form,
                                    "lName",
                                    $event.target.value
                                  )
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c("p", { staticClass: "help is-danger" }, [
                              _vm._v(
                                "\n                                " +
                                  _vm._s(_vm.errors.first("lName")) +
                                  "\n                            "
                              )
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "field" }, [
                          _vm._v(
                            "\n                            Company:\n                            "
                          ),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.form.company,
                                expression: "form.company"
                              }
                            ],
                            staticClass: "input is-warning",
                            attrs: { type: "text", name: "Company" },
                            domProps: { value: _vm.form.company },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.form,
                                  "company",
                                  $event.target.value
                                )
                              }
                            }
                          })
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "field",
                            class: { formError: _vm.errors.first("City") }
                          },
                          [
                            _vm._v(
                              "\n                            City:*\n                            "
                            ),
                            _c("input", {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: "required",
                                  expression: "'required'"
                                },
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.form.city,
                                  expression: "form.city"
                                }
                              ],
                              staticClass: "input is-warning",
                              attrs: {
                                type: "text",
                                name: "City",
                                autocomplete: "city"
                              },
                              domProps: { value: _vm.form.city },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    _vm.form,
                                    "city",
                                    $event.target.value
                                  )
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c("p", { staticClass: "help is-danger" }, [
                              _vm._v(
                                "\n                                " +
                                  _vm._s(_vm.errors.first("City")) +
                                  "\n                            "
                              )
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "field",
                            class: { formError: _vm.errors.first("Country") }
                          },
                          [
                            _vm._v("\n                            Country:*"),
                            _c("br"),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "select is-warning width100" },
                              [
                                _c(
                                  "select",
                                  {
                                    directives: [
                                      {
                                        name: "validate",
                                        rawName: "v-validate",
                                        value: "required",
                                        expression: "'required'"
                                      },
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.form.country,
                                        expression: "form.country"
                                      }
                                    ],
                                    staticClass: "width100",
                                    attrs: { name: "Country" },
                                    on: {
                                      change: function($event) {
                                        var $$selectedVal = Array.prototype.filter
                                          .call($event.target.options, function(
                                            o
                                          ) {
                                            return o.selected
                                          })
                                          .map(function(o) {
                                            var val =
                                              "_value" in o ? o._value : o.value
                                            return val
                                          })
                                        _vm.$set(
                                          _vm.form,
                                          "country",
                                          $event.target.multiple
                                            ? $$selectedVal
                                            : $$selectedVal[0]
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _c(
                                      "option",
                                      { attrs: { disabled: "", value: "" } },
                                      [_vm._v("Select...")]
                                    ),
                                    _vm._v(" "),
                                    _vm._l(_vm.countries, function(item) {
                                      return _c(
                                        "option",
                                        {
                                          key: item.code,
                                          domProps: { value: item.code }
                                        },
                                        [_vm._v(_vm._s(item.name))]
                                      )
                                    })
                                  ],
                                  2
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c("p", { staticClass: "help is-danger" }, [
                              _vm._v(
                                "\n                                " +
                                  _vm._s(_vm.errors.first("Country")) +
                                  "\n                            "
                              )
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "field",
                            class: { formError: _vm.errors.first("Password") }
                          },
                          [
                            _vm._v(
                              "\n                            Password:*\n                            "
                            ),
                            _c("input", {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: {
                                    required: true,
                                    min: 8,
                                    regex: /(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[$@$!%*#?&])/
                                  },
                                  expression:
                                    "{required: true, min:8, regex: /(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[$@$!%*#?&])/}"
                                },
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.form.password,
                                  expression: "form.password"
                                }
                              ],
                              staticClass: "input is-warning",
                              attrs: { type: "password", name: "Password" },
                              domProps: { value: _vm.form.password },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    _vm.form,
                                    "password",
                                    $event.target.value
                                  )
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c("p", { staticClass: "help is-danger" }, [
                              _vm._v(
                                "\n                                " +
                                  _vm._s(_vm.errors.first("Password")) +
                                  "\n                            "
                              )
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "field",
                            class: { formError: _vm.errors.first("password2") }
                          },
                          [
                            _vm._v(
                              "\n                            Confirm Password:*\n                            "
                            ),
                            _c("input", {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: {
                                    required: true,
                                    is: _vm.form.password
                                  },
                                  expression:
                                    "{required:true, is: form.password}"
                                }
                              ],
                              staticClass: "input is-warning",
                              attrs: { type: "password", name: "password2" }
                            }),
                            _vm._v(" "),
                            _c("p", { staticClass: "help is-danger" }, [
                              _vm._v(
                                "\n                                " +
                                  _vm._s(_vm.errors.first("password2")) +
                                  "\n                            "
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                staticClass: "is-size-8 has-text-weight-light"
                              },
                              [
                                _vm._v(
                                  "(At least 8 characters long, at least one number, at least one lowercase letter, at least one uppercase letter and at least one special character)"
                                )
                              ]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "field",
                            class: { formError: _vm.errors.first("terms") }
                          },
                          [
                            _c("label", { staticClass: "checkbox" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "required",
                                    expression: "'required'"
                                  },
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.form.terms,
                                    expression: "form.terms"
                                  }
                                ],
                                attrs: { type: "checkbox", name: "terms" },
                                domProps: {
                                  checked: Array.isArray(_vm.form.terms)
                                    ? _vm._i(_vm.form.terms, null) > -1
                                    : _vm.form.terms
                                },
                                on: {
                                  change: function($event) {
                                    var $$a = _vm.form.terms,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = null,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          _vm.$set(
                                            _vm.form,
                                            "terms",
                                            $$a.concat([$$v])
                                          )
                                      } else {
                                        $$i > -1 &&
                                          _vm.$set(
                                            _vm.form,
                                            "terms",
                                            $$a
                                              .slice(0, $$i)
                                              .concat($$a.slice($$i + 1))
                                          )
                                      }
                                    } else {
                                      _vm.$set(_vm.form, "terms", $$c)
                                    }
                                  }
                                }
                              }),
                              _vm._v(
                                "\n                                *I agree to the "
                              ),
                              _c(
                                "a",
                                {
                                  staticClass: "has-text-warning",
                                  attrs: { href: "#" }
                                },
                                [_c("b", [_vm._v("terms and conditions")])]
                              ),
                              _vm._v(" "),
                              _c("p", { staticClass: "help is-danger" }, [
                                _vm._v(
                                  "\n                                    " +
                                    _vm._s(_vm.errors.first("terms")) +
                                    "\n                                "
                                )
                              ])
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "field" }, [
                          _c("div", {
                            staticClass: "g-recaptcha",
                            attrs: {
                              id: "recaptcha-main",
                              "data-sitekey":
                                "6LdPJ7caAAAAABSJZ2-94XxGY_h_7Ux38kc1YfYc"
                            }
                          })
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "field" }, [
                          _c(
                            "button",
                            {
                              staticClass: "button is-warning top10",
                              attrs: { id: "save", type: "submit" }
                            },
                            [_vm._v("SUBMIT")]
                          )
                        ])
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                !_vm.showForm
                  ? _c("div", [
                      _c(
                        "div",
                        { staticClass: "subtitle has-text-dark is-size-3" },
                        [_c("b", [_vm._v("Thank you for registering! ")])]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "has-text-dark is-size-5" }, [
                        _vm._v(
                          "\n                            Your information has been saved and your registration is complete."
                        ),
                        _c("br"),
                        _c("br"),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "is-size-4 roundPad has-background-turk has-text-white"
                          },
                          [
                            _c("br"),
                            _vm._v(
                              "\n                                If you are trying a slink for free, it has has been activated and is ready to go."
                            ),
                            _c("br"),
                            _c("br"),
                            _vm._v(" "),
                            _c("b", [
                              _vm._v(
                                "Change it's redirection URL or configure it's subslinks via the "
                              ),
                              _c(
                                "span",
                                {
                                  staticClass: "has-text-primary handCursor",
                                  on: {
                                    click: function($event) {
                                      return _vm.$router.push("/mng")
                                    }
                                  }
                                },
                                [_vm._v("Manage Sevices")]
                              ),
                              _vm._v(" page.")
                            ]),
                            _vm._v(" "),
                            _c("br"),
                            _vm._v(" "),
                            _c("br")
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "top20" }, [
                        _c(
                          "button",
                          {
                            staticClass: "button is-turk",
                            on: { click: _vm.login }
                          },
                          [_vm._v("LOG IN")]
                        )
                      ])
                    ])
                  : _vm._e()
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "column" })
          ])
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2c39d7b2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2c39d7b2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/CompleteReg.vue
// module id = null
// module chunks = 